module.exports = __webpack_public_path__ + "img/mainImg2_phone.3b0927f6.png";